module.exports = __webpack_public_path__ + "media/auto_history/badanie_techniczne-blue-8c7f82a0.svg";